module.exports = __webpack_public_path__ + "media/ranch_farm.12bef986.jpg";